import React, { useCallback, useContext } from 'react';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { AnalyticContext } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-starred/src/common/controllers/analytics-context/index.tsx';
import type { JiraStarredOLFItem } from './JiraRecentOLFItem.types.tsx';
import { StarJiraItemButton } from './StarJiraItemButton.tsx';

export function StarredMenuLinkItemAdaptor(params: JiraStarredOLFItem): React.JSX.Element {
	const {
		analytics,
		defaultIsStarred = true,
		elemBefore,
		href,
		id,
		onClick,
		primaryLabel,
		typename,
	} = params;

	const { fireUIAnalyticForStarredItems } = useContext(AnalyticContext);
	const handleClick = useCallback(
		(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			fireUIAnalyticForStarredItems(analytics);
			// It's important to call onClick so that the flyout closes when the menu item is clicked
			onClick?.(event);
		},
		[analytics, fireUIAnalyticForStarredItems, onClick],
	);

	return (
		<LinkMenuItem
			elemBefore={elemBefore}
			actions={
				<StarJiraItemButton
					analytics={analytics}
					defaultIsStarred={defaultIsStarred}
					id={id}
					name={primaryLabel}
					typename={typename}
				/>
			}
			href={href || ''}
			onClick={handleClick}
		>
			{primaryLabel}
		</LinkMenuItem>
	);
}
